/* eslint-disable id-length */
import { getSubSteps } from '#models/general/steps';

import { getCalculationsFields } from './calculations';
import { getInitialPageFields } from './initialPage';
import { getSRWVFirstPageFields, getSRWVSecondPageFields } from './srwv';
import { getWaterReadingsFields } from './waterReadings';

export const SPIRIT_REDUCTIONS_SUBSTEP_TARGET = 'AdelphiSpiritReductionsModal';

export const SPIRIT_REDUCTIONS_SUBSTEPS_IDS = {
  INITIAL_PAGE: 'initialPage',
  SRWV_FIRST_PAGE: 'srwvFirstPage',
  SRWV_SECOND_PAGE: 'srwvSecondPage',
  CALCULATIONS: 'calculations',
  WATER_READINGS: 'waterReadings'
};

const SPIRIT_REDUCTIONS_NEXT_SUBSTEPS = {
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS
};

const SPIRIT_REDUCTIONS_PREVIOUS_SUBSTEPS = {
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS]: SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS
};

export const SPIRIT_REDUCTIONS_SUBSTEPS = getSubSteps(
  SPIRIT_REDUCTIONS_SUBSTEP_TARGET,
  SPIRIT_REDUCTIONS_SUBSTEPS_IDS,
  SPIRIT_REDUCTIONS_NEXT_SUBSTEPS,
  SPIRIT_REDUCTIONS_PREVIOUS_SUBSTEPS
);

export const SPIRIT_REDUCTIONS_COMPLETE_FIELDS = {
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE]: getInitialPageFields,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS]: getCalculationsFields,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE]: getSRWVFirstPageFields,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE]: getSRWVSecondPageFields,
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS]: getWaterReadingsFields
};

export const SPIRIT_REDUCTIONS_SUBSTEPS_ADDITION_PROPS = {
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.INITIAL_PAGE]: {
    oneColumnForm: true
  },
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.CALCULATIONS]: {
    oneColumnForm: true
  },
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_FIRST_PAGE]: {
    oneColumnForm: true
  },
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.SRWV_SECOND_PAGE]: {
    oneColumnForm: true
  },
  [SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS]: {
    oneColumnForm: true
  }
};

export const ADELPHI_SPIRIT_REDUCTIONS_SUBSTEPS_INFO = {
  target: SPIRIT_REDUCTIONS_SUBSTEP_TARGET,
  substeps: SPIRIT_REDUCTIONS_SUBSTEPS,
  fields: SPIRIT_REDUCTIONS_COMPLETE_FIELDS,
  additionalProps: SPIRIT_REDUCTIONS_SUBSTEPS_ADDITION_PROPS
};

export const SPIRIT_REDUCTION_INITIAL_PAGE_FIELDS = {
  PERIOD_ID: 'periodId',
  FILL_ID: 'fillId',
  DATE: 'date',
  OPERATOR: 'operator'
};

export const SPIRIT_REDUCTION_CALCULATIONS_FIELDS = {
  BULK_X_TCF: 'bulkXTcf',
  CBULK_X_STRENGTH: 'cbulkXStrength',
  LALC_CALCULATION: 'lalcCalculation',
  MINUS_CBULK: 'minusCbulk',
  PLUS_9: 'plus9',
  TOTAL_WATER: 'totalWater',
  NEW_METER_READING: 'newMeterReading'
};

export const SPIRIT_REDUCTION_SRWV_FIELDS = {
  DIP_ORIGINAL: 'dipOriginal',
  DIP_REDUCED: 'dipReduced',
  BULK_ORIGINAL: 'bulkOriginal',
  BULK_REDUCED: 'bulkReduced',
  TEMP_ORIGINAL: 'tempOriginal',
  TEMP_REDUCED: 'tempReduced',
  IND_ORIGINAL: 'indOriginal',
  IND_REDUCED: 'indReduced',
  STRENGTH_ORIGINAL: 'strengthOriginal',
  STRENGTH_REDUCED: 'strengthReduced',
  TCF_ORIGINAL: 'tcfOriginal',
  TCF_REDUCED: 'tcfReduced',
  CBULK_ORIGINAL: 'cbulkOriginal',
  CBULK_REDUCED: 'cbulkReduced',
  LALC_ORIGINAL: 'lalcOriginal',
  LALC_REDUCED: 'lalcReduced'
};

export const SPIRIT_REDUCTION_WATER_READINGS_FIELDS = {
  READING_BEFORE: 'readingBefore',
  READING_AFTER: 'readingAfter',
  WATER_USAGE: 'waterUsage'
};
